export default __webpack_public_path__ + "static/media/banner20260517-mobile.30cc4c32.jpg";